import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HotelListComponent } from "./hotel-list.component";
import { I18nModule } from "src/app/core/languages-support/i18n.module";
import { AppSupportedLanguages } from "src/app/core/languages-support/i18n-config.service";
import { FiltersPanelModule } from "src/app/libs/ui/components/filters-panel/filters-panel.module";
import { HotelListRoutingModule } from "./hotels-list-routing.module";
import { HotelsResultCardModule } from "../hotels-result-card/hotels-result-card.module";
import { SearchFormModule } from "src/app/libs/ui/components/search-form/search-form.module";
import { TicketHeroModule } from "src/app/libs/ui/components/ticket-hero/ticket-hero.module";
import { HotelFiltersModule } from "../hotel-filters/hotel-filters.module";
import { LoaderModule } from "src/app/libs/ui/components/loader/loader.module";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { SearchFormPanelModule } from "src/app/libs/ui/components/search-form-panel/search-form-panel.module";
import { QuickFilterModule } from "src/app/libs/ui/components/quick-filter/quick-filter.module";
import { PriceSummaryModule } from "../../../../../libs/ui/components/price-summary/price-summary.module";
import { FilterSkeletonModule } from "../../../../../libs/ui/components/filter-skeleton/filter-skeleton.module";
import { SortFiltersModule } from "src/app/libs/ui/components/sort-filters/sort-filters.module";
import { SummaryCardModule } from "src/app/libs/ui/components/summary-card/summary-card.module";
import { HotelCardSkeletonModule } from "../hotel-card-skeleton/hotel-card-skeleton.module";
import { CurrencyExchangeConverterModule } from "src/app/libs/common/pipes/currency-exhange-converter/currency-exhange-convertermodule";
@NgModule({
    declarations: [HotelListComponent],
    exports: [HotelListComponent],
    imports: [
        CommonModule,
        HotelListRoutingModule,
        I18nModule.forRoot(AppSupportedLanguages),
        FiltersPanelModule,
        HotelsResultCardModule,
        SearchFormModule,
        TicketHeroModule,
        HotelFiltersModule,
        LoaderModule,
        InfiniteScrollModule,
        PriceSummaryModule,
        FilterSkeletonModule,
        CommonModule,
        SearchFormPanelModule,
        QuickFilterModule,
        PriceSummaryModule,
        SortFiltersModule,
        SummaryCardModule,
        HotelCardSkeletonModule,
        CurrencyExchangeConverterModule
    ]
})
export class HotelListModule {}
